/** Log prefix for cubiq requests output */
export const REQUEST_LOG_PREFIX = "cub-req";
/** Log prefix for cubiq responses output */
export const RESPONSE_LOG_PREFIX = "cub-res";
/** Log prefix for cubiq messages output */
export const MESSAGE_LOG_PREFIX = "cub-m";

export enum LogMessageTimeType {
  /** No time logging */
  NONE,
  /** Add time to every log message */
  MESSAGE,
  /** Only output a time once in each time interval */
  MAX_INTERVAL,
}

// Output a new log time every minute
export const MAX_TIME_INTERVAL = 60000;

export const LOG_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss.sss Z";
export const LOG_TIME_FORMAT = "HH:mm:ss.sss";
export const SHORT_ID_LENGTH: number = 8;
